export default __webpack_public_path__ + "static/new-lk-ad2d63492a3d0294662d5064487c318b.svg";